import { flowRight, fromPairs, get, set } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { withPropsOnChange } from 'recompose';

import recommendations, { categories } from 'common/choices/recommendations';
import Group from 'components/form/Group';
import TypedCollection from 'components/form/TypedCollection';
import TypedBlockCollectionItem from 'components/form/TypedBlockCollectionItem';
import { formValues } from 'redux-form';
import { withSession } from '../../../../sessions';
import FinancialFields from './FinancialFields';
import RealEstateFields from './RealEstateFields';
import FinancialCIFFields from './FinancialCIFFields';

const RecommendationLists = ({ name, instancedTypes, isCif = false, rip, target, required }) => (
    instancedTypes.map(([category, types]) => (
        <Group title={categories[category]} key={category} required={required}>
            <TypedCollection
                name={name}
                types={types}
                textOnly
                itemComponent={TypedBlockCollectionItem}
                isCif={isCif}
                rip={rip}
                target={target}
                required={required}
            />
        </Group>
    ))
);
RecommendationLists.propTypes = {
    name: PropTypes.string.isRequired,
    instancedTypes: PropTypes.shape({}),
    required: PropTypes.bool,
    session: PropTypes.shape({
        entity: PropTypes.shape({
            canRequestCifScpiRecommendation: PropTypes.bool,
        }),
    }).isRequired,
};

export default flowRight([
    withSession,
    formValues('target', 'choicePreco'),
    withPropsOnChange(['recommendations', 'choicePreco', 'target', 'session'], ({ recommendations: ripRecommmendations, choicePreco, rip, target, session }) => {
        const groupedTypes = Object.entries({
            lifeInsurance: FinancialFields,
            LODEOM: FinancialFields,
            SCPI: FinancialFields,
            dismemberedSCPI: FinancialFields,
            PERP: FinancialFields,
            Madelin: FinancialFields,
            PER: FinancialFields,
            diversification: FinancialFields,
            otherFinancial: FinancialFields,
            Malraux: RealEstateFields,
            LMNP: RealEstateFields,
            PinelDenormandie: RealEstateFields,
            landDeficit: RealEstateFields,
            otherRealEstate: RealEstateFields,
            LODEOMCIF: FinancialCIFFields,
            SCPIRendement: FinancialCIFFields,
            SCPIaCredit: FinancialCIFFields,
            SCPIDemembreeCIF: FinancialCIFFields,
            privateRental: RealEstateFields,
        }).reduce((types, [key, component]) => {
            const typeDefinition = recommendations[key];

            return set(
                [typeDefinition.category, key],
                { ...typeDefinition, unique: true, component },
                types,
            );
        }, {});

        if (null === ripRecommmendations || !ripRecommmendations.PERP) {
            delete groupedTypes.financial.PERP;
        }
        if (null === ripRecommmendations || !ripRecommmendations.Madelin) {
            delete groupedTypes.financial.Madelin;
        }
        const isCa = session.permissions.isCaseManager();
        if ('cif' === choicePreco) {
            // TODO 1821 - à retirer pour l'ouverture à tous les conseillers
            if (!get('entity.canRequestCifScpiRecommendation', session) && !isCa) {
                delete groupedTypes.financialCif.SCPIRendement;
                delete groupedTypes.financialCif.SCPIaCredit;
                delete groupedTypes.financialCif.SCPIDemembreeCIF;
            }
            delete groupedTypes.realEstate;
            delete groupedTypes.financial;
        } else {
            delete groupedTypes.financialCif;
        }

        return ({
            instancedTypes: Object
                .entries(groupedTypes)
                .map(([category, types]) => [
                    category,
                    fromPairs(Object.entries(types).map(([key, data]) => [key, {
                        ...data,
                        defaultValues: {
                            ...data.defaultValues,
                            ...get([key, 'data'], ripRecommmendations),

                        },
                        rip,
                        target,
                    }])),
                ]),
        });
    }),
])(RecommendationLists);
